import type React from 'react';
import Card from '../atoms/Card';

export interface ErrorStateProps {
  message: string;
  icon?: React.ReactNode;
  className?: string;
}

const DefaultErrorIcon = () => (
  <svg className="w-5 h-5 text-danger" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const ErrorState: React.FC<ErrorStateProps> = ({
  message,
  icon,
  className = ''
}) => (
    <Card variant="bordered" className={`border-danger-border bg-danger-light max-w-sm ${className}`}>
      <div className="flex items-center space-x-2">
        {icon ?? <DefaultErrorIcon />}
        <p className="text-sm text-danger font-medium">{message}</p>
      </div>
    </Card>
  );

ErrorState.displayName = 'ErrorState';

export default ErrorState;